import { render, staticRenderFns } from "./PagespeedReportWrapper.vue?vue&type=template&id=6bd3af52&"
import script from "./PagespeedReportWrapper.vue?vue&type=script&lang=js&"
export * from "./PagespeedReportWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports